<div class="modal-header">
  <h4 class="modal-title">
    {{ pageTitle }}
  </h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row" *ngIf="stock">
    <div class="col-md-12">
      <label for="">Warehouse: </label>
      <span
        ><b> &nbsp; {{ stock.warehouse.location_name }}</b></span
      >
    </div>
  </div>
  <div class="row" *ngIf="!locationId">
    <div class="col-md-12">
      <div class="form-group">
        <label for="">Search Location</label>
        <ng-select
          [items]="location$ | async"
          bindValue="id"
          bindLabel="location_name"
          [typeahead]="locationInput$"
          [(ngModel)]="locationIds"
          multiple="true"
          [loading]="locationLoading"
          (scroll)="onScroll($event)"
          (scrollToEnd)="onScrollToEnd()"
        >
        </ng-select>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="ftLotTracking && rfqLotTracking">
    <div class="col-md-12">
      <div class="form-group">
        <label for="">Lot Number</label>
        <ng-select
          [items]="rfqLots"
          bindValue="id"
          bindLabel="lot_number"
          [(ngModel)]="lotId"
        >
        </ng-select>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    class="btn btn-primary"
    type="submit"
    [disabled]="loading"
    (click)="save()"
    [ngClass]="{
      'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
    }"
  >
    Add Locations
  </button>
</div>
